import { ACTIVE_INFO_PANEL, PASSIVE_INFO_PANEL } from './actionTypes';

export const activeInfoPanel = (layer) => (dispatch) => {
  dispatch({
    type: ACTIVE_INFO_PANEL,
    payload: layer,
  });
};

export const passiveInfoPanel = (layer) => (dispatch) => {
  dispatch({
    type: PASSIVE_INFO_PANEL,
    payload: layer,
  });
};
